import React, { forwardRef } from "react";
import { BSDiv } from "../../types";

export const Card = forwardRef<HTMLDivElement, BSDiv>(
  ({ children, className = "", ...props }, ref) => {
    return (
      <div {...props} className={`card ${className}`} ref={ref}>
        {children}
      </div>
    );
  }
);